import { useHandleDistrictFilter, useHandleSchoolFilter } from './AdminDistrictSchoolSelectorHook';
import SearchDistrictAction from '../components/actions/search-district/SearchDistrictAction';
import SearchSchoolAction from '../components/actions/search-school/SearchSchoolAction';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './AdminDistrictSchoolSelector.scss';

const defaultProps = {
  onDataLoadSuccess: () => null,
};
const AdminDistrictSchoolSelector = (props) => {
  const { onDataLoadSuccess } = { ...defaultProps, ...filterUndefined(props) };
  const {
    selectedDistrictId,
    handleOnDistrictChange,
  } = useHandleDistrictFilter();

  const {
    schoolsData,
    handleOnSchoolsLoaded,
    selectedSchoolId,
    handleOnFilterSchoolChange,
  } = useHandleSchoolFilter({
    onDataLoadSuccess,
  });

  return (
    <div className='admin-district-school-selector'>
      <SearchDistrictAction
        className='district-school-selector-dropdown'
        onFilterChange={handleOnDistrictChange}
        filterValue={selectedDistrictId}
        isMultiple={false}
        ableToUnselectedInSingleMode
      />
      <SearchSchoolAction
        className='district-school-selector-dropdown margin-top'
        districtId={selectedDistrictId}
        schoolsData={schoolsData}
        onSchoolsLoaded={handleOnSchoolsLoaded}
        isMultiple={false}
        filterValue={schoolsData && schoolsData.find((s) => s.id === selectedSchoolId) ? selectedSchoolId : null}
        onFilterChange={handleOnFilterSchoolChange}
      />
    </div>
  );
};

export default AdminDistrictSchoolSelector;
